import { Box } from "@mui/material";
import { format } from "date-fns";
// import { RefereesActionsPopover } from "./referees-actions-popover";

export const getRefereesColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Referral ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.id ?? "N/A"}
      </div>
    ),
  },

  {
    accessorKey: "referralUser",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Referrer</div>,
    cell: ({ row }) => (
      <div>
        <div style={{ fontSize: "0.85rem", fontWeight: 500 }}>
          {row.original.referralUser?.name || "N/A"}
        </div>

        <div
          style={{
            fontSize: "0.75rem",
            color: "#6b7280",
            whiteSpace: "nowrap",
          }}
        >
          {row.original.referralUser?.email || "No Email"}
        </div>
      </div>
    ),
  },

  {
    accessorKey: "refereeUser",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Referee</div>,
    cell: ({ row }) => (
      <div>
        <div style={{ fontSize: "0.85rem", fontWeight: 500 }}>
          {row.original.refereeUser?.name || "N/A"}
        </div>

        <div
          style={{
            fontSize: "0.75rem",
            color: "#6b7280",
            whiteSpace: "nowrap",
          }}
        >
          {row.original.refereeUser?.email || "No Email"}
        </div>
      </div>
    ),
  },

  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Referred</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {date ? format(new Date(date), "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },

  {
    accessorKey: "status",
    header: () => <div>Status</div>,
    cell: () => {
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "#f0fdf4",
            color: "#15803d",
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: "#16a34a",
            }}
          />
          Successful
        </Box>
      );
    },
  },
  // {
  //   id: "actions",
  //   header: () => <div>Action</div>,
  //   cell: ({ row }) => (
  //     <Stack direction="row" justifyContent="center">
  //       <RefereesActionsPopover
  //         referee={row.original}
  //         onEditClick={onEditClick}
  //       />
  //     </Stack>
  //   ),
  // },
];
